import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ProfileModal from './ProfileModal';

const NAV = [
  { label: 'Dashboard', icon: '⊞', path: '/' },
  { label: 'Search',    icon: '⌕', path: '/search' },
  { label: 'Cleanup',   icon: '⚡', path: '/cleanup' },
];

/** Returns initials from firstName + lastName, falls back to first char of username */
function initials(user) {
  if (user?.firstName && user?.lastName) {
    return (user.firstName[0] + user.lastName[0]).toUpperCase();
  }
  return user?.username?.[0]?.toUpperCase() ?? 'U';
}

/** Best display name: fullName → firstName → username */
function displayName(user) {
  return user?.fullName || user?.firstName || user?.username || 'User';
}

export default function Sidebar({ mobileOpen, onClose }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [showProfile, setShowProfile] = useState(false);
  
  const go = (path) => { navigate(path); onClose?.(); };

  return (
    <>
      <aside className={`sidebar ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-logo">
          <div className="logo-icon">📄</div>
          <span className="logo-text">Memora</span>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section-label">Menu</div>
          {NAV.map(n => (
            <button
              key={n.path}
              className={`nav-item-btn ${pathname === n.path ? 'active' : ''}`}
              onClick={() => go(n.path)}
            >
              <span className="nav-icon">{n.icon}</span>
              {n.label}
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
            {/* Changed onClick to open ProfileModal and updated the label */}
            <div className="user-chip" onClick={() => setShowProfile(true)} title="View Profile">
              <div className="user-avatar">
                {initials(user)}
              </div>
              <div className="user-info">
                <div className="user-name">{displayName(user)}</div>
                <div className="user-role">View Profile</div>
              </div>
            </div>
          </div>
      </aside>
      {/* Render the modal outside the aside element */}
      {showProfile && <ProfileModal onClose={() => setShowProfile(false)} />}
    </>
  );
}
